import React from 'react';
import { DraftsIcon } from '@miroculus/nucleo';
import classnames from 'classnames/bind';
import styles from './ProtocolCreation.scss';
const cx = classnames.bind(styles);
export const buildTeamOption = ({ name, id }) => ({
    label: name,
    value: id,
    disabled: false,
});
export const buildOrganizationOption = ({ name }, organizationColorIndex) => {
    const optionLabel = (React.createElement("div", { className: cx(`colorBubble${organizationColorIndex % 3}`) }, name));
    return { label: optionLabel, value: name, disabled: true };
};
export const buildDraftsOption = (personalTeam) => ({
    label: (React.createElement("div", { className: cx('optionWithIcon') },
        React.createElement(DraftsIcon, null),
        "Drafts")),
    value: personalTeam.id,
});
export const buildLocationOptions = (organizations, teamId, personalTeam) => organizations.reduce((opts, org) => {
    // Skip if the team is not in the current organization
    if (!org.teams.find((t) => t.id === teamId))
        return opts;
    return [
        ...opts,
        buildOrganizationOption({ name: org.name }, 0),
        ...org.teams.map(buildTeamOption),
    ];
}, personalTeam ? [buildDraftsOption(personalTeam)] : []);
